import { IRequest } from "interfaces/models/IRequest";
import { IUser } from "interfaces/models/IUser";

const mapRequestToUser = (request : IRequest) : IUser => {
  const user : IUser = {
    userId: request.userId,
    username: request.username,
    emailAddress: request.emailAddress,
    federatedADName: request.federatedACName
  };

  return user;
};

export { mapRequestToUser };
